<template>
    <div class="section">
        <transactions-user-table :user="user"></transactions-user-table>
        <delete-user-transaction-modal v-if="isDeleteModal"></delete-user-transaction-modal>
    </div>
</template>

<script>
    import TransactionsUserTable from "./TransactionsUserTable";
    import DeleteUserTransactionModal from "./DeleteUserTransactionModal";
    export default {
        props: ['user'],
        components: {
            DeleteUserTransactionModal,
            TransactionsUserTable,
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isDeleteModal() {
                return this.$store.getters.getTransactionDeleteModalStatus
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UserBanking/TransactionsUser.vue